/**
 * @packageDocumentation
 * @module Updater
 * @category Core
 */
import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { UpdaterService } from './updater.service';

/**
 * Инициализация отслеживания обновлений.
 */
export function provideUpdater(): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => {
      const initializerFn = ((_) => () => {})(inject(UpdaterService));
      return initializerFn();
    }),
  ];
}
